import {
  Percent,
  IndianRupee,
  Users,
  Wallet,
  ArrowUpRight
} from "lucide-react";
import './statscards.css'

const stats = [
  {
    label: "Conversion Rate",
    value: "72%",
    trend: "+5%",
    icon: Percent,
    color: "green"
  },
  {
    label: "Avg. Ticket Size",
    value: "₹3.2L",
    trend: "+12%",
    icon: IndianRupee,
    color: "teal"
  },
  {
    label: "Total Referrals",
    value: "156",
    trend: "+8%",
    icon: Users,
    color: "orange"
  },
  {
    label: "Total Earnings",
    value: "₹2.1L",
    trend: "+15%",
    icon: Wallet,
    color: "purple"
  }
];

export default function AnalyticsStatsCards() {
  return (
    <div className="rp-analytics-stats-grid">
      {stats.map((item, i) => {
        const Icon = item.icon;

        return (
          <div
            key={i}
            className={`rp-analytics-stat-card rp-${item.color}`}
          >
            <div className="rp-analytics-stat-top">
              <div className="rp-analytics-stat-icon">
                <Icon size={20} />
              </div>

              <div className="rp-analytics-stat-trend">
                <ArrowUpRight size={14} />
                {item.trend}
              </div>
            </div>

            <p className="rp-analytics-stat-label">
              {item.label}
            </p>
            <h2 className="rp-analytics-stat-value">
              {item.value}
            </h2>
          </div>
        );
      })}
    </div>
  );
}
